import { QueryClient, useQuery } from '@tanstack/react-query';

import { axiosForAnonymousHudson } from '@telialt/utils/src/axios/axiosForAnonymousHudson';
import { datadogLogger } from '@telialt/utils/src/datadog/datadogLogger';
import { DDComponent } from '@telialt/utils/src/datadog/setup';
import { getLayoutPath } from '@telialt/utils/src/getLayoutPath';

import { API } from '../api';
import { getFallbackData, QUERY_KEYS } from '../constants';
import { NavigationResponseData } from '../model';

const apiGetNavigationData = (layoutPath: string) =>
    axiosForAnonymousHudson
        .get<NavigationResponseData>(API.NAVIGATION, {
            params: { path: layoutPath, fieldSet: 'navigation,additional_menu' },
        })
        .catch((error) => {
            const datadogLogs = datadogLogger();
            datadogLogs.error(error, { component: DDComponent.Navbar, isFallback: true });

            return { data: getFallbackData(layoutPath) };
        });

export const useNavigation = ({ pathname }: { pathname: string }) => {
    const layoutPath = getLayoutPath(pathname);

    return useQuery<NavigationResponseData>({
        queryKey: [QUERY_KEYS.NAVIGATION, layoutPath],
        queryFn: async () => (await apiGetNavigationData(layoutPath)).data,
    });
};

export const prefetchNavigationData = (queryClient: QueryClient, pathname: string) => {
    const layoutPath = getLayoutPath(pathname);

    return queryClient.fetchQuery({
        queryKey: [QUERY_KEYS.NAVIGATION, layoutPath],
        queryFn: async () => (await apiGetNavigationData(layoutPath)).data,
    });
};
